module.exports = {
      id: "slider-right-arrow-usage",
      viewBox: "0 0 40 40",
      url: __webpack_public_path__ + "svg-sprite-f952e3bcb1151291994742cd359b350c.svg#slider-right-arrow",
      toString: function () {
        return this.url;
      }
    }